import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, message, Modal, Input } from 'antd'
import custom from '../../config/custom'
import _ from 'lodash'
import Timer from '../Timer'
import HasPermission from '../HasPermission'
import { request } from '../../utils/http'
import { updateDispatchById } from '../../modules/dispatch'

const confirm = Modal.confirm
const { TextArea } = Input

class DispatchStatus extends Component {

  constructor(props) {
    super(props)

    this.state = {
      cancelComment: '',
      canceling: false,
      closing: false,
      sendingReceivedEmail: false,
      sendingApprovedEmail: false,
    }
  }

  getDispatch() {
    return _.find(this.props.dispatches, { id: this.props.id })
  }

  getReceivedAt() {
    return this.getDispatch().receivedAt
  }

  getApprovedAt() {
    return this.getDispatch().approvedAt
  }

  getStartedAt() {
    return this.getDispatch().startedAt
  }

  getFinishedAt() {
    return this.getDispatch().finishedAt
  }

  getClosedAt() {
    return this.getDispatch().closedAt
  }

  received(e) {
    e.stopPropagation()

    this.setState({
      sendingReceivedEmail: true
    })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/received`)
      .then(response => {
        message.success('Solicitud recibida')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo marcar como recibida')
      })
      .then(() => {
        this.setState({
          sendingReceivedEmail: false
        })
      })
  }

  approved(e) {
    e.stopPropagation()

    this.setState({
      sendingApprovedEmail: true
    })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/approved`)
      .then(response => {
        message.success('Solicitud aprobada')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo aprobar el tránsito')
      })
      .then(() => {
        this.setState({
          sendingApprovedEmail: false
        })
      })
  }

  cancel(e) {
    e.stopPropagation()

    confirm({
      title: 'Cancelar tránsito?',
      content: <TextArea placeholder={'Comentario requerido'} onChange={e => { this.setState({ cancelComment: e.target.value }) }} />,
      okText: 'Confirmar',
      okType: 'danger',
      cancelText: 'Cerrar',
      maskClosable: true,
      onOk: () => {
        if (!this.state.cancelComment) {
          return true
        }

        this.setState({ canceling: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/canceled`, {
          params: {
            comment: this.state.cancelComment
          }
        })
          .then(response => {
            message.success('Tránsito cancelado')

            this.props.updateDispatchById(this.props.id)
          })
          .catch(() => {
            message.warning('No se pudo cancelar el tránsito')
          })
          .then(() => {
            this.setState({ canceling: false })
          })
      },
      onCancel: () => {

      },
    })
  }

  downloadStamp(stampId) {
    window.open(`${custom.baseUrl}/stampfile/${stampId}/download`);
  }

  close(e) {
    e.stopPropagation()

    confirm({
      title: 'Cerrar tránsito?',
      content: 'Una vez cerrado no se podrá editar la información del tránsito',
      okText: 'Sí',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ closing: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/closed`)
          .then(response => {
            message.success('Tránsito cerrado');
            this.props.updateDispatchById(this.props.id)
          })
          .catch(() => {
            message.warning('No se pudo cerrar el tránsito')
          })
          .then(() => {
            this.setState({ closing: false })
          })
      },
      onCancel: () => {

      },
    })
  }

  render() {
    return (
      <Fragment>
        {
          !this.getReceivedAt() &&
          <Button
            type={'primary'}
            loading={this.state.sendingReceivedEmail}
            onClick={e => { this.received(e) }}
          >
            Marcar como recibida
                    </Button>
        }
        {
          this.getReceivedAt() &&
          !this.getApprovedAt() &&
          < Button
            type={'primary'}
            loading={this.state.sendingApprovedEmail}
            onClick={e => { this.approved(e) }}
          >
            Aprobar solicitud
          </Button>
        }
        {
          this.getReceivedAt() &&
          this.getApprovedAt() &&
          <Timer id={this.props.id} start={this.getStartedAt()} end={this.getFinishedAt()} />
        }
        {
          !this.getFinishedAt() &&
          <Button
            loading={this.state.canceling}
            onClick={(e) => { this.cancel(e) }}
            style={{ marginLeft: 10 }}
            type={'danger'}
          >
            {this.state.canceling ? 'Cancelando...' : 'Cancelar tránsito'}
          </Button>
        }
        {
          this.getFinishedAt() &&
          !this.getClosedAt() &&
          <HasPermission name="Cerrar">
            <Button
              loading={this.state.closing}
              onClick={(e) => { this.close(e) }}
              style={{ marginLeft: 10 }}
              type={'primary'}
            >
              {this.state.closing ? 'Cerrando...' : 'Cerrar tránsito'}
            </Button>
          </HasPermission>
        }
      </Fragment>
    )
  }

}

const mapStateToProps = state => ({
  dispatches: state.dispatch.items
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateDispatchById
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DispatchStatus)



// WEBPACK FOOTER //
// ./src/containers/DispatchStatus/index.js